export { withClearButton } from './_clearButton/Badge_clearButton';
